import type { ComponentType } from 'react';
import {
  APP_ROUTES,
  REQUEST_ROUTES,
  CASH_DEPOSIT_ROUTES,
  FUND_REQUEST_ROUTES,
  CONSUMER_AUTH_ROUTES,
  PAYOUT_CLAIM_ROUTES,
  DEFERRED_ORIGINATION_ROUTES,
  M2M_ROUTES,
  SEND_ROUTES,
  STARTER_ROUTES,
  SMART_ROUTES,
  LOLA_ROUTES,
} from '../constants';
import { CashDepositLandingPage } from '../pages/CashDepositLandingPage';
import { CashStoresPage } from '../pages/CashStoresPage';
import { CashStoresBarcodeExpiredPage } from '../pages/CashStoresBarcodeExpiredPage';
import { CashStoresAmountMismatchPage } from '../pages/CashStoresAmountMismatchPage';
import { PaymentVerificationPage } from '../pages/PaymentVerificationPage';
import { DepositOnTheWayPage } from '../pages/DepositOnTheWayPage';
import { StoresPage } from '../pages/StoresPage';
import { StoresMapPage } from '../pages/StoresMapPage';
import { FundRequestPage } from '../pages/FundRequestPage';
import { LegalPage } from '../pages/LegalPage';
import { ErrorPage } from '../shared/error/pages/ErrorPage';
import { SessionExpiredPage } from '../shared/error/pages/SessionExpiredPage';
import { CancellationInProgressPage } from '../shared/error/pages/CancellationInProgressPage';
import { CancellationFailedPage } from '../shared/error/pages/CancellationFailedPage';
import { ServiceUnavailablePage } from '../shared/error/pages/ServiceUnavailablePage';
import { MaintenanceGalleryPage } from '../shared/error/pages/MaintenanceGalleryPage';
import { LoadingPage as RequestLoadingPage } from '../pages/request/LoadingPage';
import { WelcomePage as RequestWelcomePage } from '../pages/request/WelcomePage';
import { LandingPage as RequestLandingPage, LandingReturningPage as RequestLandingReturningPage } from '../pages/request/LandingPage';
import {
  HomePage as RequestHomePage,
  UserRestrictedHomePage as RequestUserRestrictedHomePage,
  InboxPage as RequestInboxPage,
  PreferencesPage as RequestPreferencesPage,
  ToastPage as RequestToastPage,
} from '../pages/request/HomePage';
import { TransferPage as RequestTransferPage } from '../pages/request/TransferPage';
import { AddCardPage as RequestAddCardPage } from '../pages/request/AddCardPage';
import { AddCardProcessingPage as RequestAddCardProcessingPage } from '../pages/request/AddCardProcessingPage';
import { MintingPage as RequestMintingPage } from '../pages/request/MintingPage';
import { RequestScreeningPage } from '../pages/request/RequestScreeningPage';
import { RequestReadyPage } from '../pages/request/RequestReadyPage';
import { TermDetailPage as RequestTermDetailPage } from '../pages/request/TermDetailPage';
import { ServiceUnavailablePage as RequestServiceUnavailablePage } from '../pages/request/ServiceUnavailablePage';
import { LoadingPage as CashDepositLoadingPage } from '../pages/cash-deposit/LoadingPage';
import { WelcomePage as CashDepositWelcomePage } from '../pages/cash-deposit/WelcomePage';
import { TermDetailPage as CashDepositTermDetailPage } from '../pages/cash-deposit/TermDetailPage';
import { SupportPage as CashDepositSupportPage } from '../pages/cash-deposit/SupportPage';
import { HowToPayInCashPage as CashDepositHowToPayInCashPage } from '../pages/cash-deposit/HowToPayInCashPage';
import { LoadingPage as FundRequestLoadingPage } from '../pages/fund-request/LoadingPage';
import { WelcomePage as FundRequestWelcomePage } from '../pages/fund-request/WelcomePage';
import { TransferPage as FundRequestTransferPage } from '../pages/fund-request/TransferPage';
import { CvvPrepareGatePage as FundRequestCvvPrepareGatePage } from '../pages/fund-request/CvvPrepareGatePage';
import {
  TransactionsPage as FundRequestTransactionsPage,
  DepositLaunchingTransactionsPage as FundRequestDepositLaunchingTransactionsPage,
  InboxPage as FundRequestInboxPage,
  PreferencesPage as FundRequestPreferencesPage,
  ToastPage as FundRequestToastPage,
} from '../pages/fund-request/TransactionsPage';
import { TermDetailPage as FundRequestTermDetailPage } from '../pages/fund-request/TermDetailPage';
import { BillingAddressPage as FundRequestBillingAddressPage } from '../pages/fund-request/BillingAddressPage';
import { AddCardPage as FundRequestAddCardPage } from '../pages/fund-request/AddCardPage';
import { AddCardProcessingPage as FundRequestAddCardProcessingPage } from '../pages/fund-request/AddCardProcessingPage';
import {
  SendingMoneyPage as FundRequestSendingMoneyPage,
  TransferringPage as FundRequestTransferringPage,
} from '../pages/fund-request/SendingMoneyPage';
import { HowToDepositCashPage as FundRequestHowToDepositCashPage } from '../pages/fund-request/HowToDepositCashPage';
import { ReceiptSummaryPage as FundRequestReceiptSummaryPage } from '../pages/fund-request/ReceiptSummaryPage';
import { SupportPage as FundRequestSupportPage } from '../pages/fund-request/SupportPage';
import { RequestAlreadyFulfilledPage as FundRequestAlreadyFulfilledPage } from '../pages/fund-request/RequestAlreadyFulfilledPage';
import { IntentionLaterPage as FundRequestIntentionLaterPage } from '../pages/fund-request/IntentionLaterPage';
import { IntentionDiscardPage as FundRequestIntentionDiscardPage } from '../pages/fund-request/IntentionDiscardPage';
import { RouteUnavailablePage as FundRequestRouteUnavailablePage } from '../pages/fund-request/RouteUnavailablePage';
import { ReceiptSummaryPage as RequestReceiptSummaryPage } from '../pages/request/ReceiptSummaryPage';
import { SupportPage as RequestSupportPage } from '../pages/request/SupportPage';
import { LoadingPage as M2MLoadingPage } from '../pages/m2m/LoadingPage';
import { WelcomePage as M2MWelcomePage } from '../pages/m2m/WelcomePage';
import { TermDetailPage as M2MTermDetailPage } from '../pages/m2m/TermDetailPage';
import {
  LandingFlavorAPage as M2MLandingFlavorAPage,
  LandingFlavorBPage as M2MLandingFlavorBPage,
} from '../pages/m2m/LandingPage';
import { TransferFlavorAPage } from '../pages/m2m/TransferFlavorAPage';
import { TransferFlavorBPage } from '../pages/m2m/TransferFlavorBPage';
import { TransferFlavorCPage } from '../pages/m2m/TransferFlavorCPage';
import {
  TransactionsPage as M2MTransactionsPage,
  UserRestrictedTransactionsPage as M2MUserRestrictedTransactionsPage,
  InboxPage as M2MInboxPage,
  PreferencesPage as M2MPreferencesPage,
  ToastPage as M2MToastPage,
} from '../pages/m2m/TransactionsPage';
import { SupportV2Page } from '../pages/m2m/SupportV2Page';
import { AddCardProcessingPage as M2MAddCardProcessingPage } from '../pages/m2m/AddCardProcessingPage';
import { AddCardCollectPage as M2MAddCardCollectPage } from '../pages/m2m/AddCardCollectPage';
import { AddCardPage as M2MAddCardPage } from '../pages/m2m/AddCardPage';
import { AddCardAddressPage as M2MAddCardAddressPage } from '../pages/m2m/AddCardAddressPage';
import {
  SendingMoneyFlavorAPage as M2MSendingMoneyFlavorAPage,
  SendingMoneyFlavorBPage as M2MSendingMoneyFlavorBPage,
} from '../pages/m2m/SendingMoneyPage';
import { ReceiptSummaryPage as M2MReceiptSummaryPage } from '../pages/m2m/ReceiptSummaryPage';
import { LoadingPage as StarterLoadingPage } from '../pages/starter/LoadingPage';
import { WelcomePage as StarterWelcomePage } from '../pages/starter/WelcomePage';
import { LandingPage as StarterLandingPage } from '../pages/starter/LandingPage';
import { TermDetailPage as StarterTermDetailPage } from '../pages/starter/TermDetailPage';
import { RotateToPortraitPage as StarterRotateToPortraitPage } from '../pages/starter/RotateToPortraitPage';
import { LoadingPage as SendLoadingPage } from '../pages/send/LoadingPage';
import { WelcomePage as SendWelcomePage } from '../pages/send/WelcomePage';
import { LandingPage as SendLandingPage, LandingReturningPage as SendLandingReturningPage } from '../pages/send/LandingPage';
import {
  HomePage as SendHomePage,
  UserRestrictedHomePage as SendUserRestrictedHomePage,
  DepositLaunchingHomePage as SendDepositLaunchingHomePage,
  InboxPage as SendInboxPage,
  PreferencesPage as SendPreferencesPage,
  ToastPage as SendToastPage,
} from '../pages/send/HomePage';
import { TransferPage as SendTransferPage } from '../pages/send/TransferPage';
import { CvvPrepareGatePage as SendCvvPrepareGatePage } from '../pages/send/CvvPrepareGatePage';
import { AddCardPage as SendAddCardPage } from '../pages/send/AddCardPage';
import { BillingAddressPage as SendBillingAddressPage } from '../pages/send/BillingAddressPage';
import { AddCardProcessingPage as SendAddCardProcessingPage } from '../pages/send/AddCardProcessingPage';
import { SendingMoneyPage as SendSendingMoneyPage } from '../pages/send/SendingMoneyPage';
import { HowToDepositCashPage as SendHowToDepositCashPage } from '../pages/send/HowToDepositCashPage';
import { ReceiptSummaryPage as SendReceiptSummaryPage } from '../pages/send/ReceiptSummaryPage';
import { SupportPage as SendSupportPage } from '../pages/send/SupportPage';
import { TermDetailPage as SendTermDetailPage } from '../pages/send/TermDetailPage';
import { LoadingPage as PayoutClaimLoadingPage } from '../pages/payout-claim/LoadingPage';
import { WelcomePage as PayoutClaimWelcomePage } from '../pages/payout-claim/WelcomePage';
import { PayoutClaimEntryPage } from '../pages/payout-claim/PayoutClaimEntryPage';
import { IntentionLaterPage as PayoutClaimIntentionLaterPage } from '../pages/payout-claim/IntentionLaterPage';
import { IntentionDiscardPage as PayoutClaimIntentionDiscardPage } from '../pages/payout-claim/IntentionDiscardPage';
import {
  TransferPage as PayoutClaimTransferPage,
  TransferPrepareErrorPage as PayoutClaimTransferPrepareErrorPage,
} from '../pages/payout-claim/TransferPage';
import { TransactionsPage as PayoutClaimTransactionsPage, InboxPage as PayoutClaimInboxPage, PreferencesPage as PayoutClaimPreferencesPage, ToastPage as PayoutClaimToastPage } from '../pages/payout-claim/TransactionsPage';
import { ReceiptSummaryPage as PayoutClaimReceiptSummaryPage } from '../pages/payout-claim/ReceiptSummaryPage';
import { SupportPage as PayoutClaimSupportPage } from '../pages/payout-claim/SupportPage';
import { TermDetailPage as PayoutClaimTermDetailPage } from '../pages/payout-claim/TermDetailPage';
import { AddCardPage as PayoutClaimAddCardPage } from '../pages/payout-claim/AddCardPage';
import { AddCardProcessingPage as PayoutClaimAddCardProcessingPage } from '../pages/payout-claim/AddCardProcessingPage';
import { SendingMoneyPage as PayoutClaimSendingMoneyPage, ClaimingPage as PayoutClaimClaimingPage } from '../pages/payout-claim/SendingMoneyPage';
import { OfacDisambiguationPage as PayoutClaimOfacPage } from '../pages/payout-claim/OfacDisambiguationPage';
import { ClaimBlockedPage } from '../pages/payout-claim/ClaimBlockedPage';
import {
  DeferredUserBlockedPage,
  FundRequestOriginatorBlockedPage,
  FundRequestSubjectBlockedPage,
  PayoutClaimSenderBlockedPage,
  PayoutClaimSubjectBlockedPage,
  RequestUserBlockedPage,
  SendUserBlockedPage,
  M2MUserBlockedPage,
  CashDepositUserBlockedPage,
} from '../shared/error/pages/UserStatusPage';
import {
  AuthSignInPage,
  AuthSignInAfterLogoutPage,
  AuthSignInBindFailedPage,
  AuthCodePage,
  AuthCodeResendReadyPage,
  AuthCodeIncorrectPage,
  AuthBindingPage,
  AuthMissingKeyPage,
  AuthPendingPage,
  AuthErrorBindPage,
  AuthErrorGenericPage,
} from '../pages/consumer-auth/AuthPage';
import { LoadingPage as DeferredOriginationLoadingPage } from '../pages/deferred-origination/LoadingPage';
import { WelcomePage as DeferredOriginationWelcomePage } from '../pages/deferred-origination/WelcomePage';
import { LandingPage as DeferredOriginationLandingPage, LandingReturningPage as DeferredOriginationLandingReturningPage } from '../pages/deferred-origination/LandingPage';
import {
  HomePage as DeferredOriginationHomePage,
  UserRestrictedHomePage as DeferredOriginationUserRestrictedHomePage,
  DepositLaunchingHomePage as DeferredOriginationDepositLaunchingHomePage,
  InboxPage as DeferredOriginationInboxPage,
  PreferencesPage as DeferredOriginationPreferencesPage,
  ToastPage as DeferredOriginationToastPage,
} from '../pages/deferred-origination/HomePage';
import { TransferPage as DeferredOriginationTransferPage } from '../pages/deferred-origination/TransferPage';
import { RecipientPage as DeferredOriginationRecipientPage } from '../pages/deferred-origination/RecipientPage';
import { CvvPrepareGatePage as DeferredOriginationCvvPrepareGatePage } from '../pages/deferred-origination/CvvPrepareGatePage';
import { AddCardPage as DeferredOriginationAddCardPage } from '../pages/deferred-origination/AddCardPage';
import { BillingAddressPage as DeferredOriginationBillingAddressPage } from '../pages/deferred-origination/BillingAddressPage';
import { AddCardProcessingPage as DeferredOriginationAddCardProcessingPage } from '../pages/deferred-origination/AddCardProcessingPage';
import { MintingPage as DeferredOriginationMintingPage } from '../pages/deferred-origination/MintingPage';
import { HowToDepositCashPage as DeferredOriginationHowToDepositCashPage } from '../pages/deferred-origination/HowToDepositCashPage';
import { RequestReadyPage as DeferredOriginationRequestReadyPage } from '../pages/deferred-origination/RequestReadyPage';
import { ReceiptSummaryPage as DeferredOriginationReceiptSummaryPage } from '../pages/deferred-origination/ReceiptSummaryPage';
import { SupportPage as DeferredOriginationSupportPage } from '../pages/deferred-origination/SupportPage';
import { TermDetailPage as DeferredOriginationTermDetailPage } from '../pages/deferred-origination/TermDetailPage';
import { ServiceUnavailablePage as DeferredOriginationServiceUnavailablePage } from '../pages/deferred-origination/ServiceUnavailablePage';
import { LoadingPage as SmartLoadingPage } from '../pages/smart/LoadingPage';
import {
  HomePage as SmartHomePage,
  InboxPage as SmartInboxPage,
  PreferencesPage as SmartPreferencesPage,
  ToastPage as SmartToastPage,
} from '../pages/smart/HomePage';
import { WizardIntentPage as SmartWizardIntentPage } from '../pages/smart/WizardIntentPage';
import { WizardRoutePage as SmartWizardRoutePage } from '../pages/smart/WizardRoutePage';
import { WizardFundingPage as SmartWizardFundingPage } from '../pages/smart/WizardFundingPage';
import { WizardPayoutPage as SmartWizardPayoutPage } from '../pages/smart/WizardPayoutPage';
import { CollectRecipientPage as SmartCollectRecipientPage } from '../pages/smart/CollectRecipientPage';
import { CollectSummaryPage as SmartCollectSummaryPage } from '../pages/smart/CollectSummaryPage';
import { CommittingPage as SmartCommittingPage } from '../pages/smart/CommittingPage';
import { SendDonePage as SmartSendDonePage } from '../pages/smart/SendDonePage';
import { ShareLinkDonePage as SmartShareLinkDonePage } from '../pages/smart/ShareLinkDonePage';
import { MerchantPickerPage as SmartMerchantPickerPage } from '../pages/smart/MerchantPickerPage';
import { BarcodePage as SmartBarcodePage } from '../pages/smart/BarcodePage';
import {
  ClaimFailPage as SmartClaimFailPage,
  ClaimFailReturnPage as SmartClaimFailReturnPage,
  ErrorPage as SmartErrorPage,
} from '../pages/smart/ErrorPage';
import { MaintenancePage as SmartMaintenancePage } from '../pages/smart/MaintenancePage';
import {
  SmsTermsDetailPage as SmartSmsTermsDetailPage,
  SmsTermsPage as SmartSmsTermsPage,
} from '../pages/smart/SmsTermsPage';
import {
  KycCheckingPage as SmartKycCheckingPage,
  KycErrorPage as SmartKycErrorPage,
  KycIntroPage as SmartKycIntroPage,
} from '../pages/smart/KycGatePages';
import {
  CipAddressPage as SmartCipAddressPage,
  CipClaimingPage as SmartCipClaimingPage,
  CipCompletionProcessingPage as SmartCipCompletionProcessingPage,
  CipCompletionSuccessPage as SmartCipCompletionSuccessPage,
  CipIdentityReviewPage as SmartCipIdentityReviewPage,
  CipLivenessCapturePage as SmartCipLivenessCapturePage,
  CipLivenessLoadingPage as SmartCipLivenessLoadingPage,
  CipLivenessRetryPage as SmartCipLivenessRetryPage,
  CipScanIdLoadingPage as SmartCipScanIdLoadingPage,
  CipScanIdPage as SmartCipScanIdPage,
} from '../pages/smart/CipStepPages';
import { LoadingPage as LolaLoadingPage } from '../pages/lola/LoadingPage';
import { WelcomePage as LolaWelcomePage } from '../pages/lola/WelcomePage';
import { ConfirmationPage as LolaConfirmationPage } from '../pages/lola/ConfirmationPage';
import { CvvPrepareGatePage as LolaCvvPrepareGatePage } from '../pages/lola/CvvPrepareGatePage';
import { HowToCashDepositPage as LolaHowToCashDepositPage } from '../pages/lola/HowToCashDepositPage';
import { AddCardPage as LolaAddCardPage } from '../pages/lola/AddCardPage';
import { BillingAddressPage as LolaBillingAddressPage } from '../pages/lola/BillingAddressPage';
import { AddCardProcessingPage as LolaAddCardProcessingPage } from '../pages/lola/AddCardProcessingPage';
import {
  TransferringPage as LolaTransferringPage,
  SendingMoneyPage as LolaSendingMoneyPage,
} from '../pages/lola/SendingMoneyPage';
import { TermDetailPage as LolaTermDetailPage } from '../pages/lola/TermDetailPage';
import { RouteUnavailablePage as LolaRouteUnavailablePage } from '../pages/lola/RouteUnavailablePage';
import { LinkAlreadyUsedPage as LolaLinkAlreadyUsedPage } from '../pages/lola/LinkAlreadyUsedPage';
import { CipPage as LolaCipPage } from '../pages/lola/CipPage';
import { firstSendRoute } from './firstSendMock';
import {
  phoneScreen,
  type PhoneCaptureState,
  type PhoneChrome,
} from '../pages/phone-capture/PhoneNumberPage';
import {
  smsTermsDetailScreen,
  smsTermsScreen,
  type SmsTermsChrome,
} from '../pages/sms-terms/SmsTermsPage';

export type GalleryScreenCategory =
  | 'm2m'
  | 'cash-deposit'
  | 'fund-request'
  | 'payout-claim'
  | 'consumer-auth'
  | 'deferred-origination'
  | 'request'
  | 'send'
  | 'smart'
  | 'lola'
  | 'starter';

export interface GalleryScreen {
  id: string;
  /** Human label shown in the Control Dock. */
  label: string;
  /** Optional tooltip when the label is abbreviated in the dock. */
  hint?: string;
  /** Route path used by react-router. */
  route: string;
  /** Functional group for the Control Dock screen list. */
  category: GalleryScreenCategory;
  Component: ComponentType;
}

export interface GalleryScreenGroup {
  id: GalleryScreenCategory;
  label: string;
  screens: GalleryScreen[];
}

export const GALLERY_SCREEN_GROUP_DEFS: ReadonlyArray<{
  id: GalleryScreenCategory;
  label: string;
}> = [
  { id: 'starter', label: 'Starter' },
  { id: 'm2m', label: 'M2M' },
  { id: 'cash-deposit', label: 'Cash Deposit' },
  { id: 'fund-request', label: 'Fund Request' },
  { id: 'payout-claim', label: 'Payout Claim' },
  { id: 'deferred-origination', label: 'Deferred Origination' },
  { id: 'request', label: 'Request' },
  { id: 'send', label: 'Send Money' },
  { id: 'smart', label: 'Smart' },
  { id: 'lola', label: 'Lola' },
  { id: 'consumer-auth', label: 'Consumer Auth' },
];

/**
 * Ordered list of every screen available in the gallery.
 * The Control Dock renders this list to let you jump between screens, and the
 * router maps each `route` to its `Component`.
 */
const PHONE_STATES: ReadonlyArray<{
  state: PhoneCaptureState;
  suffix: string;
  label: string;
}> = [
  { state: 'empty', suffix: '', label: 'Phone' },
  { state: 'invalid', suffix: '/invalid', label: 'Phone (invalid)' },
  { state: 'saving', suffix: '/saving', label: 'Phone (saving)' },
  { state: 'error', suffix: '/save-error', label: 'Phone (save error)' },
  { state: 'other', suffix: '/other-country', label: 'Phone (other country)' },
];

/** Phone capture inside a flow, so the dock shows that flow's chrome. */
const phoneGalleryScreens = (
  category: GalleryScreenCategory,
  idPrefix: string,
  base: string,
  chrome: PhoneChrome,
  namespace?: string,
): GalleryScreen[] =>
  PHONE_STATES.map(({ state, suffix, label }) => ({
    id: `${idPrefix}-phone${suffix.replace(/\//g, '-')}`,
    label,
    route: `${base}${suffix}`,
    category,
    Component: phoneScreen(state, chrome, namespace),
  }));

/** SMS opt-in inside a flow, next to that flow's phone capture. */
const smsTermsGalleryScreens = (
  category: GalleryScreenCategory,
  idPrefix: string,
  base: string,
  chrome: SmsTermsChrome,
  namespace?: string,
): GalleryScreen[] => [
  {
    id: `${idPrefix}-sms-terms`,
    label: 'SMS terms',
    route: base,
    category,
    Component: smsTermsScreen(chrome, namespace, `${base}/detail`),
  },
  {
    id: `${idPrefix}-sms-terms-detail`,
    label: 'SMS terms (detail)',
    route: `${base}/detail`,
    category,
    Component: smsTermsDetailScreen(chrome, base),
  },
];

export const galleryScreens: GalleryScreen[] = [
  {
    id: 'm2m-loading',
    label: 'Loading (Splash)',
    route: M2M_ROUTES.LOADING,
    category: 'm2m',
    Component: M2MLoadingPage,
  },
  {
    id: 'm2m-welcome',
    label: 'Welcome (Consent)',
    route: M2M_ROUTES.WELCOME,
    category: 'm2m',
    Component: M2MWelcomePage,
  },
  {
    id: 'm2m-term-esign',
    label: 'E-sign Consent',
    route: `${M2M_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'm2m',
    Component: M2MTermDetailPage,
  },
  {
    id: 'm2m-term-detail',
    label: 'Terms & Conditions',
    route: `${M2M_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'm2m',
    Component: M2MTermDetailPage,
  },
  {
    id: 'm2m-legal',
    label: 'Legal Documents',
    route: M2M_ROUTES.LEGAL,
    category: 'm2m',
    Component: LegalPage,
  },
  {
    id: 'm2m-landing',
    label: 'Landing (Flavor A)',
    route: M2M_ROUTES.LANDING,
    category: 'm2m',
    Component: M2MLandingFlavorAPage,
  },
  {
    id: 'm2m-landing-b',
    label: 'Landing (Flavor B)',
    route: M2M_ROUTES.LANDING_B,
    category: 'm2m',
    Component: M2MLandingFlavorBPage,
  },
  {
    id: 'm2m-transactions',
    label: 'Hub',
    route: M2M_ROUTES.TRANSACTIONS,
    category: 'm2m',
    Component: M2MTransactionsPage,
  },
  {
    id: 'm2m-inbox',
    label: 'Inbox',
    route: M2M_ROUTES.INBOX,
    category: 'm2m',
    Component: M2MInboxPage,
  },
  {
    id: 'm2m-preferences',
    label: 'Preferences',
    route: M2M_ROUTES.PREFERENCES,
    category: 'm2m',
    Component: M2MPreferencesPage,
  },
  {
    id: 'm2m-toast',
    label: 'Toast',
    route: M2M_ROUTES.TOAST,
    category: 'm2m',
    Component: M2MToastPage,
  },
  {
    id: 'm2m-transfer-flavor-a',
    label: 'Transfer (Flavor A)',
    route: M2M_ROUTES.TRANSFER_A,
    category: 'm2m',
    Component: TransferFlavorAPage,
  },
  {
    id: 'm2m-transfer-flavor-b',
    label: 'Transfer (Flavor B)',
    route: M2M_ROUTES.TRANSFER_B,
    category: 'm2m',
    Component: TransferFlavorBPage,
  },
  {
    id: 'm2m-transfer-flavor-c',
    label: 'Transfer (Flavor C)',
    route: M2M_ROUTES.TRANSFER_C,
    category: 'm2m',
    Component: TransferFlavorCPage,
  },
  {
    id: 'm2m-transfer-flavor-a-first-send',
    label: 'Transfer A (First send warning)',
    route: firstSendRoute(M2M_ROUTES.TRANSFER_A),
    category: 'm2m',
    Component: TransferFlavorAPage,
  },
  {
    id: 'm2m-transfer-flavor-b-first-send',
    label: 'Transfer B (First send warning)',
    route: firstSendRoute(M2M_ROUTES.TRANSFER_B),
    category: 'm2m',
    Component: TransferFlavorBPage,
  },
  {
    id: 'm2m-transfer-flavor-c-first-send',
    label: 'Transfer C (First send warning)',
    route: firstSendRoute(M2M_ROUTES.TRANSFER_C),
    category: 'm2m',
    Component: TransferFlavorCPage,
  },
  {
    id: 'm2m-transactions-restricted',
    label: 'Hub (User Restricted)',
    route: M2M_ROUTES.TRANSACTIONS_RESTRICTED,
    category: 'm2m',
    Component: M2MUserRestrictedTransactionsPage,
  },
  {
    id: 'm2m-user-blocked',
    label: 'Transfers Unavailable',
    route: M2M_ROUTES.USER_BLOCKED,
    category: 'm2m',
    Component: M2MUserBlockedPage,
  },
  {
    id: 'm2m-add-card',
    label: 'Add Card',
    route: M2M_ROUTES.ADD_CARD,
    category: 'm2m',
    Component: M2MAddCardPage,
  },
  {
    id: 'm2m-add-card-address',
    label: 'Add Card Address',
    route: M2M_ROUTES.ADD_CARD_ADDRESS,
    category: 'm2m',
    Component: M2MAddCardAddressPage,
  },
  {
    id: 'm2m-add-card-collect',
    label: 'Add Card Collect',
    route: M2M_ROUTES.ADD_CARD_COLLECT,
    category: 'm2m',
    Component: M2MAddCardCollectPage,
  },
  {
    id: 'm2m-add-card-processing',
    label: 'Add Card Processing',
    route: M2M_ROUTES.ADD_CARD_PROCESSING,
    category: 'm2m',
    Component: M2MAddCardProcessingPage,
  },
  ...phoneGalleryScreens('m2m', 'm2m', '/m2m/phone', 'plain'),
  ...smsTermsGalleryScreens('m2m', 'm2m', '/m2m/sms-terms', 'plain', 'm2m'),
  {
    id: 'm2m-sending',
    label: 'Sending Money (Flavor A)',
    route: M2M_ROUTES.SENDING,
    category: 'm2m',
    Component: M2MSendingMoneyFlavorAPage,
  },
  {
    id: 'm2m-sending-b',
    label: 'Sending Money (Flavor B)',
    route: M2M_ROUTES.SENDING_B,
    category: 'm2m',
    Component: M2MSendingMoneyFlavorBPage,
  },
  {
    id: 'm2m-receipt',
    label: 'Receipt',
    route: M2M_ROUTES.RECEIPT,
    category: 'm2m',
    Component: M2MReceiptSummaryPage,
  },
  {
    id: 'm2m-support-v2',
    label: 'Contact / Support',
    route: M2M_ROUTES.SUPPORT_V2,
    category: 'm2m',
    Component: SupportV2Page,
  },
  {
    id: 'm2m-error',
    label: 'Error',
    route: M2M_ROUTES.ERROR,
    category: 'm2m',
    Component: ErrorPage,
  },
  {
    id: 'm2m-session-expired',
    label: 'Session Expired',
    route: M2M_ROUTES.SESSION_EXPIRED,
    category: 'm2m',
    Component: SessionExpiredPage,
  },
  {
    id: 'm2m-service-unavailable',
    label: 'Service Unavailable',
    route: M2M_ROUTES.SERVICE_UNAVAILABLE,
    category: 'm2m',
    Component: ServiceUnavailablePage,
  },
  {
    id: 'cash-deposit-loading',
    label: 'Loading (Splash)',
    route: CASH_DEPOSIT_ROUTES.LOADING,
    category: 'cash-deposit',
    Component: CashDepositLoadingPage,
  },
  {
    id: 'cash-deposit-welcome',
    label: 'Welcome (Consent)',
    route: CASH_DEPOSIT_ROUTES.WELCOME,
    category: 'cash-deposit',
    Component: CashDepositWelcomePage,
  },
  {
    id: 'cash-deposit-term-esign',
    label: 'E-sign Consent',
    route: `${CASH_DEPOSIT_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'cash-deposit',
    Component: CashDepositTermDetailPage,
  },
  {
    id: 'cash-deposit-term-detail',
    label: 'Terms & Conditions',
    route: `${CASH_DEPOSIT_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'cash-deposit',
    Component: CashDepositTermDetailPage,
  },
  {
    id: 'cash-deposit-legal',
    label: 'Legal Documents',
    route: CASH_DEPOSIT_ROUTES.LEGAL,
    category: 'cash-deposit',
    Component: LegalPage,
  },
  {
    id: 'cash-deposit-landing',
    label: 'Cash Deposit Landing',
    route: APP_ROUTES.CASH_DEPOSIT_LANDING_PAGE,
    category: 'cash-deposit',
    Component: CashDepositLandingPage,
  },
  ...phoneGalleryScreens('cash-deposit', 'cash-deposit', '/cash-deposit/phone', 'need-help', 'cash-deposit'),
  {
    id: 'stores',
    label: 'Stores Picker',
    hint: 'Shown when requireCustomerToChooseChain is true',
    route: APP_ROUTES.STORES_PAGE,
    category: 'cash-deposit',
    Component: StoresPage,
  },
  {
    id: 'cash-stores',
    label: 'Cash Stores',
    route: APP_ROUTES.CASH_STORES_PAGE,
    category: 'cash-deposit',
    Component: CashStoresPage,
  },
  {
    id: 'cash-deposit-how-to-pay-in-cash',
    label: 'How to Pay in Cash',
    route: CASH_DEPOSIT_ROUTES.HOW_TO_PAY_IN_CASH,
    category: 'cash-deposit',
    Component: CashDepositHowToPayInCashPage,
  },
  {
    id: 'cash-stores-barcode-expired',
    label: 'Barcode · Expired',
    route: APP_ROUTES.CASH_STORES_BARCODE_EXPIRED_PAGE,
    category: 'cash-deposit',
    Component: CashStoresBarcodeExpiredPage,
  },
  {
    id: 'cash-stores-amount-mismatch',
    label: 'Barcode · Amount Mismatch',
    route: APP_ROUTES.CASH_STORES_AMOUNT_MISMATCH_PAGE,
    category: 'cash-deposit',
    Component: CashStoresAmountMismatchPage,
  },
  {
    id: 'payment-verification',
    label: 'Payment Verification',
    route: APP_ROUTES.PAYMENT_VERIFICATION_PAGE,
    category: 'cash-deposit',
    Component: PaymentVerificationPage,
  },
  {
    id: 'deposit-on-the-way',
    label: 'Deposit On The Way',
    route: APP_ROUTES.DEPOSIT_ON_THE_WAY_PAGE,
    category: 'cash-deposit',
    Component: DepositOnTheWayPage,
  },
  {
    id: 'cash-deposit-support',
    label: 'Contact / Support',
    route: CASH_DEPOSIT_ROUTES.SUPPORT,
    category: 'cash-deposit',
    Component: CashDepositSupportPage,
  },
  {
    id: 'stores-map',
    label: 'Store Locator (Map)',
    route: APP_ROUTES.STORES_MAP_PAGE,
    category: 'cash-deposit',
    Component: StoresMapPage,
  },
  {
    id: 'cash-deposit-user-blocked',
    label: 'Deposit Unavailable',
    route: CASH_DEPOSIT_ROUTES.USER_BLOCKED,
    category: 'cash-deposit',
    Component: CashDepositUserBlockedPage,
  },
  {
    id: 'cash-deposit-error',
    label: 'Error',
    route: CASH_DEPOSIT_ROUTES.ERROR,
    category: 'cash-deposit',
    Component: ErrorPage,
  },
  {
    id: 'cash-deposit-session-expired',
    label: 'Session Expired',
    route: CASH_DEPOSIT_ROUTES.SESSION_EXPIRED,
    category: 'cash-deposit',
    Component: SessionExpiredPage,
  },
  {
    id: 'cash-deposit-service-unavailable',
    label: 'Service Unavailable',
    route: CASH_DEPOSIT_ROUTES.SERVICE_UNAVAILABLE,
    category: 'cash-deposit',
    Component: ServiceUnavailablePage,
  },
  {
    id: 'fund-request-loading',
    label: 'Loading (Splash)',
    route: FUND_REQUEST_ROUTES.LOADING,
    category: 'fund-request',
    Component: FundRequestLoadingPage,
  },
  {
    id: 'fund-request-welcome',
    label: 'Welcome (Consent)',
    route: FUND_REQUEST_ROUTES.WELCOME,
    category: 'fund-request',
    Component: FundRequestWelcomePage,
  },
  {
    id: 'fund-request-term-esign',
    label: 'E-sign Consent',
    route: `${FUND_REQUEST_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'fund-request',
    Component: FundRequestTermDetailPage,
  },
  {
    id: 'fund-request-term-detail',
    label: 'Terms & Conditions',
    route: `${FUND_REQUEST_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'fund-request',
    Component: FundRequestTermDetailPage,
  },
  {
    id: 'fund-request-legal',
    label: 'Legal Documents',
    route: FUND_REQUEST_ROUTES.LEGAL,
    category: 'fund-request',
    Component: LegalPage,
  },
  {
    id: 'fund-request',
    label: 'Fund Request Page',
    route: APP_ROUTES.FUND_REQUEST_PAGE,
    category: 'fund-request',
    Component: FundRequestPage,
  },
  {
    id: 'fund-request-later',
    label: 'Later (Deferred)',
    route: FUND_REQUEST_ROUTES.LATER,
    category: 'fund-request',
    Component: FundRequestIntentionLaterPage,
  },
  {
    id: 'fund-request-discard',
    label: 'Discarded',
    route: FUND_REQUEST_ROUTES.DISCARD,
    category: 'fund-request',
    Component: FundRequestIntentionDiscardPage,
  },
  {
    id: 'fund-request-transfer',
    label: 'Transfer Page',
    route: FUND_REQUEST_ROUTES.TRANSFER,
    category: 'fund-request',
    Component: FundRequestTransferPage,
  },
  {
    id: 'fund-request-transfer-payout-currency-editable',
    label: 'Transfer (fully editable)',
    route: `${FUND_REQUEST_ROUTES.TRANSFER}?galleryAmountEdit=1&galleryPayoutEdit=1&galleryCurrencyEdit=1`,
    category: 'fund-request',
    Component: FundRequestTransferPage,
  },
  {
    id: 'fund-request-transfer-first-send',
    label: 'Transfer (First send warning)',
    route: firstSendRoute(FUND_REQUEST_ROUTES.TRANSFER),
    category: 'fund-request',
    Component: FundRequestTransferPage,
  },
  {
    id: 'fund-request-transfer-first-send-long',
    label: 'Transfer (First send, long copy)',
    route: firstSendRoute(FUND_REQUEST_ROUTES.TRANSFER, 'long'),
    category: 'fund-request',
    Component: FundRequestTransferPage,
  },
  {
    id: 'fund-request-transfer-cvv',
    label: 'Transfer (CVV Prepare)',
    route: FUND_REQUEST_ROUTES.TRANSFER_CVV,
    category: 'fund-request',
    Component: FundRequestCvvPrepareGatePage,
  },
  {
    id: 'fund-request-add-card',
    label: 'Add Card',
    route: FUND_REQUEST_ROUTES.ADD_CARD,
    category: 'fund-request',
    Component: FundRequestAddCardPage,
  },
  {
    id: 'fund-request-add-card-form-errors',
    label: 'Add Card (Field Errors)',
    route: FUND_REQUEST_ROUTES.ADD_CARD_FORM_ERRORS,
    category: 'fund-request',
    Component: FundRequestAddCardPage,
  },
  {
    id: 'fund-request-add-card-brand-error',
    label: 'Add Card (Brand Not Accepted)',
    route: FUND_REQUEST_ROUTES.ADD_CARD_BRAND_ERROR,
    category: 'fund-request',
    Component: FundRequestAddCardPage,
  },
  {
    id: 'fund-request-add-card-address',
    label: 'Billing Address',
    route: FUND_REQUEST_ROUTES.ADD_CARD_ADDRESS,
    category: 'fund-request',
    Component: FundRequestBillingAddressPage,
  },
  {
    id: 'fund-request-add-card-address-errors',
    label: 'Billing Address (Field Errors)',
    route: FUND_REQUEST_ROUTES.ADD_CARD_ADDRESS_ERRORS,
    category: 'fund-request',
    Component: FundRequestBillingAddressPage,
  },
  {
    id: 'fund-request-add-card-processing',
    label: 'Add Card Processing',
    route: FUND_REQUEST_ROUTES.ADD_CARD_PROCESSING,
    category: 'fund-request',
    Component: FundRequestAddCardProcessingPage,
  },
  {
    id: 'fund-request-add-card-error-validation',
    label: 'Add Card (Validation Failed)',
    route: FUND_REQUEST_ROUTES.ADD_CARD_ERROR_VALIDATION,
    category: 'fund-request',
    Component: FundRequestAddCardProcessingPage,
  },
  {
    id: 'fund-request-add-card-error-review',
    label: 'Add Card (Under Review)',
    route: FUND_REQUEST_ROUTES.ADD_CARD_ERROR_REVIEW,
    category: 'fund-request',
    Component: FundRequestAddCardProcessingPage,
  },
  {
    id: 'fund-request-add-card-error-generic',
    label: 'Add Card (Network / Generic Error)',
    route: FUND_REQUEST_ROUTES.ADD_CARD_ERROR_GENERIC,
    category: 'fund-request',
    Component: FundRequestAddCardProcessingPage,
  },
  {
    id: 'fund-request-add-card-error-already-registered',
    label: 'Add Card (Already Registered)',
    route: FUND_REQUEST_ROUTES.ADD_CARD_ERROR_ALREADY_REGISTERED,
    category: 'fund-request',
    Component: FundRequestAddCardProcessingPage,
  },
  {
    id: 'fund-request-add-card-error-rate-limit',
    label: 'Add Card (Too Many Attempts)',
    route: FUND_REQUEST_ROUTES.ADD_CARD_ERROR_RATE_LIMIT,
    category: 'fund-request',
    Component: FundRequestAddCardProcessingPage,
  },
  ...phoneGalleryScreens('fund-request', 'fund-request', '/fund-request/phone', 'need-help', 'fund-request'),
  ...smsTermsGalleryScreens('fund-request', 'fund-request', '/fund-request/sms-terms', 'need-help', 'fund-request'),
  {
    id: 'fund-request-transferring',
    label: 'Transferring',
    route: FUND_REQUEST_ROUTES.TRANSFERRING,
    category: 'fund-request',
    Component: FundRequestTransferringPage,
  },
  {
    id: 'fund-request-processed',
    label: 'Transfer Processed',
    route: FUND_REQUEST_ROUTES.SENDING,
    category: 'fund-request',
    Component: FundRequestSendingMoneyPage,
  },
  {
    id: 'fund-request-how-to-deposit',
    label: 'How to deposit cash',
    route: FUND_REQUEST_ROUTES.HOW_TO_DEPOSIT,
    category: 'fund-request',
    Component: FundRequestHowToDepositCashPage,
  },
  {
    id: 'fund-request-transactions',
    label: 'Transactions (List)',
    route: FUND_REQUEST_ROUTES.TRANSACTIONS,
    category: 'fund-request',
    Component: FundRequestTransactionsPage,
  },
  {
    id: 'fund-request-inbox',
    label: 'Inbox',
    route: FUND_REQUEST_ROUTES.INBOX,
    category: 'fund-request',
    Component: FundRequestInboxPage,
  },
  {
    id: 'fund-request-preferences',
    label: 'Preferences',
    route: FUND_REQUEST_ROUTES.PREFERENCES,
    category: 'fund-request',
    Component: FundRequestPreferencesPage,
  },
  {
    id: 'fund-request-toast',
    label: 'Toast',
    route: FUND_REQUEST_ROUTES.TOAST,
    category: 'fund-request',
    Component: FundRequestToastPage,
  },
  {
    id: 'fund-request-transactions-deposit-launching',
    label: 'Transactions (Deposit Launching)',
    route: FUND_REQUEST_ROUTES.TRANSACTIONS_DEPOSIT_LAUNCHING,
    category: 'fund-request',
    Component: FundRequestDepositLaunchingTransactionsPage,
  },
  {
    id: 'fund-request-receipt',
    label: 'Receipt Summary',
    route: `${FUND_REQUEST_ROUTES.RECEIPT}/op_gallery_completed`,
    category: 'fund-request',
    Component: FundRequestReceiptSummaryPage,
  },
  {
    id: 'fund-request-receipt-processing',
    label: 'Receipt Summary (Processing)',
    route: `${FUND_REQUEST_ROUTES.RECEIPT}/op_gallery_processing`,
    category: 'fund-request',
    Component: FundRequestReceiptSummaryPage,
  },
  {
    id: 'fund-request-receipt-failed',
    label: 'Receipt Summary (Failed)',
    route: `${FUND_REQUEST_ROUTES.RECEIPT}/op_gallery_failed`,
    category: 'fund-request',
    Component: FundRequestReceiptSummaryPage,
  },
  {
    id: 'fund-request-receipt-cancelled',
    label: 'Receipt Summary (Cancelled)',
    route: `${FUND_REQUEST_ROUTES.RECEIPT}/op_gallery_canceled`,
    category: 'fund-request',
    Component: FundRequestReceiptSummaryPage,
  },
  {
    id: 'fund-request-receipt-expired',
    label: 'Receipt Summary (Expired)',
    route: `${FUND_REQUEST_ROUTES.RECEIPT}/op_gallery_expired`,
    category: 'fund-request',
    Component: FundRequestReceiptSummaryPage,
  },
  {
    id: 'fund-request-support',
    label: 'Contact / Support',
    route: FUND_REQUEST_ROUTES.SUPPORT,
    category: 'fund-request',
    Component: FundRequestSupportPage,
  },
  {
    id: 'fund-request-subject-blocked',
    label: 'Account Cannot Continue',
    route: FUND_REQUEST_ROUTES.SUBJECT_BLOCKED,
    category: 'fund-request',
    Component: FundRequestSubjectBlockedPage,
  },
  {
    id: 'fund-request-originator-blocked',
    label: 'Request Unavailable (Requester Blocked)',
    route: FUND_REQUEST_ROUTES.ORIGINATOR_BLOCKED,
    category: 'fund-request',
    Component: FundRequestOriginatorBlockedPage,
  },
  {
    id: 'fund-request-already-fulfilled',
    label: 'Request Unavailable',
    route: FUND_REQUEST_ROUTES.ALREADY_FULFILLED,
    category: 'fund-request',
    Component: FundRequestAlreadyFulfilledPage,
  },
  {
    id: 'fund-request-route-unavailable',
    label: 'Route Unavailable',
    route: FUND_REQUEST_ROUTES.ROUTE_UNAVAILABLE,
    category: 'fund-request',
    Component: FundRequestRouteUnavailablePage,
  },
  {
    id: 'fund-request-error',
    label: 'Error',
    route: FUND_REQUEST_ROUTES.ERROR,
    category: 'fund-request',
    Component: ErrorPage,
  },
  {
    id: 'fund-request-session-expired',
    label: 'Session Expired',
    route: FUND_REQUEST_ROUTES.SESSION_EXPIRED,
    category: 'fund-request',
    Component: SessionExpiredPage,
  },
  {
    id: 'fund-request-service-unavailable',
    label: 'Service Unavailable',
    route: FUND_REQUEST_ROUTES.SERVICE_UNAVAILABLE,
    category: 'fund-request',
    Component: ServiceUnavailablePage,
  },
  {
    id: 'fund-request-cancellation',
    label: 'Cancellation In Progress',
    route: FUND_REQUEST_ROUTES.CANCELLATION,
    category: 'fund-request',
    Component: CancellationInProgressPage,
  },
  {
    id: 'fund-request-cancellation-failed',
    label: 'Cancellation Failed',
    route: FUND_REQUEST_ROUTES.CANCELLATION_FAILED,
    category: 'fund-request',
    Component: CancellationFailedPage,
  },
  {
    id: 'payout-claim-loading',
    label: 'Loading (Splash)',
    route: PAYOUT_CLAIM_ROUTES.LOADING,
    category: 'payout-claim',
    Component: PayoutClaimLoadingPage,
  },
  {
    id: 'payout-claim-welcome',
    label: 'Welcome (Consent)',
    route: PAYOUT_CLAIM_ROUTES.WELCOME,
    category: 'payout-claim',
    Component: PayoutClaimWelcomePage,
  },
  {
    id: 'payout-claim-term-esign',
    label: 'E-sign Consent',
    route: `${PAYOUT_CLAIM_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'payout-claim',
    Component: PayoutClaimTermDetailPage,
  },
  {
    id: 'payout-claim-term-detail',
    label: 'Terms & Conditions',
    route: `${PAYOUT_CLAIM_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'payout-claim',
    Component: PayoutClaimTermDetailPage,
  },
  {
    id: 'payout-claim-legal',
    label: 'Legal Documents',
    route: PAYOUT_CLAIM_ROUTES.LEGAL,
    category: 'payout-claim',
    Component: LegalPage,
  },
  {
    id: 'payout-claim-entry',
    label: 'Claim Entry',
    route: PAYOUT_CLAIM_ROUTES.CLAIM_ENTRY,
    category: 'payout-claim',
    Component: PayoutClaimEntryPage,
  },
  {
    id: 'payout-claim-later',
    label: 'Later (Deferred)',
    route: PAYOUT_CLAIM_ROUTES.LATER,
    category: 'payout-claim',
    Component: PayoutClaimIntentionLaterPage,
  },
  {
    id: 'payout-claim-discard',
    label: 'Discarded',
    route: PAYOUT_CLAIM_ROUTES.DISCARD,
    category: 'payout-claim',
    Component: PayoutClaimIntentionDiscardPage,
  },
  {
    id: 'payout-claim-transfer',
    label: 'Transfer (Receive)',
    route: PAYOUT_CLAIM_ROUTES.TRANSFER,
    category: 'payout-claim',
    Component: PayoutClaimTransferPage,
  },
  {
    id: 'payout-claim-transfer-prepare-error',
    label: 'Transfer (Prepare Error)',
    route: PAYOUT_CLAIM_ROUTES.TRANSFER_PREPARE_ERROR,
    category: 'payout-claim',
    Component: PayoutClaimTransferPrepareErrorPage,
  },
  {
    id: 'payout-claim-add-card',
    label: 'Add Destination Card',
    route: PAYOUT_CLAIM_ROUTES.ADD_CARD,
    category: 'payout-claim',
    Component: PayoutClaimAddCardPage,
  },
  {
    id: 'payout-claim-add-card-processing',
    label: 'Add Card Processing',
    route: PAYOUT_CLAIM_ROUTES.ADD_CARD_PROCESSING,
    category: 'payout-claim',
    Component: PayoutClaimAddCardProcessingPage,
  },
  {
    id: 'payout-claim-add-card-error-validation',
    label: 'Add Card (Validation Failed)',
    route: PAYOUT_CLAIM_ROUTES.ADD_CARD_ERROR_VALIDATION,
    category: 'payout-claim',
    Component: PayoutClaimAddCardProcessingPage,
  },
  {
    id: 'payout-claim-add-card-error-push',
    label: 'Add Card (Push Not Supported)',
    route: PAYOUT_CLAIM_ROUTES.ADD_CARD_ERROR_PUSH,
    category: 'payout-claim',
    Component: PayoutClaimAddCardProcessingPage,
  },
  ...phoneGalleryScreens('payout-claim', 'payout-claim', '/payout-claim/phone', 'need-help', 'payout-claim'),
  ...smsTermsGalleryScreens('payout-claim', 'payout-claim', '/payout-claim/sms-terms', 'need-help', 'payout-claim'),
  {
    id: 'payout-claim-claiming',
    label: 'Claiming (Processing)',
    route: PAYOUT_CLAIM_ROUTES.CLAIMING,
    category: 'payout-claim',
    Component: PayoutClaimClaimingPage,
  },
  {
    id: 'payout-claim-sending',
    label: 'Sending Money (On the way)',
    route: PAYOUT_CLAIM_ROUTES.SENDING_MONEY,
    category: 'payout-claim',
    Component: PayoutClaimSendingMoneyPage,
  },
  {
    id: 'payout-claim-ofac',
    label: 'OFAC Disambiguation',
    route: PAYOUT_CLAIM_ROUTES.OFAC,
    category: 'payout-claim',
    Component: PayoutClaimOfacPage,
  },
  {
    id: 'payout-claim-transactions',
    label: 'Transactions (List)',
    route: PAYOUT_CLAIM_ROUTES.TRANSACTIONS,
    category: 'payout-claim',
    Component: PayoutClaimTransactionsPage,
  },
  {
    id: 'payout-claim-inbox',
    label: 'Inbox',
    route: PAYOUT_CLAIM_ROUTES.INBOX,
    category: 'payout-claim',
    Component: PayoutClaimInboxPage,
  },
  {
    id: 'payout-claim-preferences',
    label: 'Preferences',
    route: PAYOUT_CLAIM_ROUTES.PREFERENCES,
    category: 'payout-claim',
    Component: PayoutClaimPreferencesPage,
  },
  {
    id: 'payout-claim-toast',
    label: 'Toast',
    route: PAYOUT_CLAIM_ROUTES.TOAST,
    category: 'payout-claim',
    Component: PayoutClaimToastPage,
  },
  {
    id: 'payout-claim-receipt',
    label: 'Receipt Summary',
    route: `${PAYOUT_CLAIM_ROUTES.RECEIPT}/op_gallery_claim_completed`,
    category: 'payout-claim',
    Component: PayoutClaimReceiptSummaryPage,
  },
  {
    id: 'payout-claim-support',
    label: 'Contact / Support',
    route: PAYOUT_CLAIM_ROUTES.SUPPORT,
    category: 'payout-claim',
    Component: PayoutClaimSupportPage,
  },
  {
    id: 'payout-claim-blocked',
    label: 'Claim Unavailable (Late Arrival)',
    route: PAYOUT_CLAIM_ROUTES.CLAIM_BLOCKED,
    category: 'payout-claim',
    Component: ClaimBlockedPage,
  },
  {
    id: 'payout-claim-subject-blocked',
    label: 'Account Cannot Continue',
    route: PAYOUT_CLAIM_ROUTES.SUBJECT_BLOCKED,
    category: 'payout-claim',
    Component: PayoutClaimSubjectBlockedPage,
  },
  {
    id: 'payout-claim-sender-blocked',
    label: 'Claim Unavailable (Sender Blocked)',
    route: PAYOUT_CLAIM_ROUTES.SENDER_BLOCKED,
    category: 'payout-claim',
    Component: PayoutClaimSenderBlockedPage,
  },
  {
    id: 'payout-claim-error',
    label: 'Error',
    route: PAYOUT_CLAIM_ROUTES.ERROR,
    category: 'payout-claim',
    Component: ErrorPage,
  },
  {
    id: 'payout-claim-session-expired',
    label: 'Session Expired',
    route: PAYOUT_CLAIM_ROUTES.SESSION_EXPIRED,
    category: 'payout-claim',
    Component: SessionExpiredPage,
  },
  {
    id: 'payout-claim-service-unavailable',
    label: 'Service Unavailable',
    route: PAYOUT_CLAIM_ROUTES.SERVICE_UNAVAILABLE,
    category: 'payout-claim',
    Component: ServiceUnavailablePage,
  },
  {
    id: 'deferred-origination-loading',
    label: 'Loading',
    route: DEFERRED_ORIGINATION_ROUTES.LOADING,
    category: 'deferred-origination',
    Component: DeferredOriginationLoadingPage,
  },
  {
    id: 'deferred-origination-welcome',
    label: 'Welcome (Consent)',
    route: DEFERRED_ORIGINATION_ROUTES.WELCOME,
    category: 'deferred-origination',
    Component: DeferredOriginationWelcomePage,
  },
  {
    id: 'deferred-origination-term-esign',
    label: 'E-sign Consent',
    route: `${DEFERRED_ORIGINATION_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'deferred-origination',
    Component: DeferredOriginationTermDetailPage,
  },
  {
    id: 'deferred-origination-term-detail',
    label: 'Terms & Conditions',
    route: `${DEFERRED_ORIGINATION_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'deferred-origination',
    Component: DeferredOriginationTermDetailPage,
  },
  {
    id: 'deferred-origination-legal',
    label: 'Legal Documents',
    route: DEFERRED_ORIGINATION_ROUTES.LEGAL,
    category: 'deferred-origination',
    Component: LegalPage,
  },
  {
    id: 'deferred-origination-landing',
    label: 'Landing',
    route: DEFERRED_ORIGINATION_ROUTES.LANDING,
    category: 'deferred-origination',
    Component: DeferredOriginationLandingPage,
  },
  {
    id: 'deferred-origination-landing-returning',
    label: 'Landing (Returning)',
    route: DEFERRED_ORIGINATION_ROUTES.LANDING_RETURNING,
    category: 'deferred-origination',
    Component: DeferredOriginationLandingReturningPage,
  },
  {
    id: 'deferred-origination-home',
    label: 'Home (Sends)',
    route: DEFERRED_ORIGINATION_ROUTES.HOME,
    category: 'deferred-origination',
    Component: DeferredOriginationHomePage,
  },
  {
    id: 'deferred-origination-inbox',
    label: 'Inbox',
    route: DEFERRED_ORIGINATION_ROUTES.INBOX,
    category: 'deferred-origination',
    Component: DeferredOriginationInboxPage,
  },
  {
    id: 'deferred-origination-preferences',
    label: 'Preferences',
    route: DEFERRED_ORIGINATION_ROUTES.PREFERENCES,
    category: 'deferred-origination',
    Component: DeferredOriginationPreferencesPage,
  },
  {
    id: 'deferred-origination-toast',
    label: 'Toast',
    route: DEFERRED_ORIGINATION_ROUTES.TOAST,
    category: 'deferred-origination',
    Component: DeferredOriginationToastPage,
  },
  {
    id: 'deferred-origination-home-deposit-launching',
    label: 'Home (Deposit Launching)',
    route: DEFERRED_ORIGINATION_ROUTES.HOME_DEPOSIT_LAUNCHING,
    category: 'deferred-origination',
    Component: DeferredOriginationDepositLaunchingHomePage,
  },
  {
    id: 'deferred-origination-home-restricted',
    label: 'Home (User Restricted)',
    route: DEFERRED_ORIGINATION_ROUTES.HOME_RESTRICTED,
    category: 'deferred-origination',
    Component: DeferredOriginationUserRestrictedHomePage,
  },
  {
    id: 'deferred-origination-transfer',
    label: 'Transfer (Compose)',
    route: DEFERRED_ORIGINATION_ROUTES.TRANSFER,
    category: 'deferred-origination',
    Component: DeferredOriginationTransferPage,
  },
  {
    id: 'deferred-origination-transfer-first-send',
    label: 'Transfer (First send warning)',
    route: firstSendRoute(DEFERRED_ORIGINATION_ROUTES.TRANSFER),
    category: 'deferred-origination',
    Component: DeferredOriginationTransferPage,
  },
  {
    id: 'deferred-origination-recipient',
    label: 'Recipient',
    route: DEFERRED_ORIGINATION_ROUTES.RECIPIENT,
    category: 'deferred-origination',
    Component: DeferredOriginationRecipientPage,
  },
  {
    id: 'deferred-origination-recipient-cvv',
    label: 'Recipient (CVV Prepare)',
    route: DEFERRED_ORIGINATION_ROUTES.RECIPIENT_CVV,
    category: 'deferred-origination',
    Component: DeferredOriginationCvvPrepareGatePage,
  },
  {
    id: 'deferred-origination-add-card',
    label: 'Add Card (Funding)',
    route: DEFERRED_ORIGINATION_ROUTES.ADD_CARD,
    category: 'deferred-origination',
    Component: DeferredOriginationAddCardPage,
  },
  {
    id: 'deferred-origination-billing-address',
    label: 'Billing Address',
    route: DEFERRED_ORIGINATION_ROUTES.ADD_CARD_ADDRESS,
    category: 'deferred-origination',
    Component: DeferredOriginationBillingAddressPage,
  },
  {
    id: 'deferred-origination-add-card-processing',
    label: 'Add Card Processing',
    route: DEFERRED_ORIGINATION_ROUTES.ADD_CARD_PROCESSING,
    category: 'deferred-origination',
    Component: DeferredOriginationAddCardProcessingPage,
  },
  ...phoneGalleryScreens(
    'deferred-origination',
    'deferred-origination',
    '/deferred-origination/phone',
    'need-help',
    'deferred-origination',
  ),
  ...smsTermsGalleryScreens(
    'deferred-origination',
    'deferred-origination',
    '/deferred-origination/sms-terms',
    'need-help',
    'deferred-origination',
  ),
  {
    id: 'deferred-origination-minting',
    label: 'Minting',
    route: DEFERRED_ORIGINATION_ROUTES.MINTING,
    category: 'deferred-origination',
    Component: DeferredOriginationMintingPage,
  },
  {
    id: 'deferred-origination-how-to-deposit',
    label: 'How to Deposit Cash',
    route: DEFERRED_ORIGINATION_ROUTES.HOW_TO_DEPOSIT,
    category: 'deferred-origination',
    Component: DeferredOriginationHowToDepositCashPage,
  },
  {
    id: 'deferred-origination-ready',
    label: 'Share Link Ready',
    route: DEFERRED_ORIGINATION_ROUTES.REQUEST_READY,
    category: 'deferred-origination',
    Component: DeferredOriginationRequestReadyPage,
  },
  {
    id: 'deferred-origination-receipt',
    label: 'Receipt Summary (Funded)',
    route: `${DEFERRED_ORIGINATION_ROUTES.RECEIPT}/dpr-gallery-funded`,
    category: 'deferred-origination',
    Component: DeferredOriginationReceiptSummaryPage,
  },
  {
    id: 'deferred-origination-receipt-pending',
    label: 'Receipt Summary (Awaiting claim)',
    route: `${DEFERRED_ORIGINATION_ROUTES.RECEIPT}/dpr-gallery-pending`,
    category: 'deferred-origination',
    Component: DeferredOriginationReceiptSummaryPage,
  },
  {
    id: 'deferred-origination-receipt-cash',
    label: 'Receipt Summary (Pay at store)',
    route: `${DEFERRED_ORIGINATION_ROUTES.RECEIPT}/dpr-gallery-cash`,
    category: 'deferred-origination',
    Component: DeferredOriginationReceiptSummaryPage,
  },
  {
    id: 'deferred-origination-support',
    label: 'Contact / Support',
    route: DEFERRED_ORIGINATION_ROUTES.SUPPORT,
    category: 'deferred-origination',
    Component: DeferredOriginationSupportPage,
  },
  {
    id: 'deferred-origination-service-unavailable',
    label: 'Service Unavailable',
    route: DEFERRED_ORIGINATION_ROUTES.SERVICE_UNAVAILABLE,
    category: 'deferred-origination',
    Component: DeferredOriginationServiceUnavailablePage,
  },
  {
    id: 'deferred-origination-user-blocked',
    label: 'Transfers Unavailable',
    route: DEFERRED_ORIGINATION_ROUTES.USER_BLOCKED,
    category: 'deferred-origination',
    Component: DeferredUserBlockedPage,
  },
  {
    id: 'deferred-origination-error',
    label: 'Error',
    route: DEFERRED_ORIGINATION_ROUTES.ERROR,
    category: 'deferred-origination',
    Component: ErrorPage,
  },
  {
    id: 'deferred-origination-session-expired',
    label: 'Session Expired',
    route: DEFERRED_ORIGINATION_ROUTES.SESSION_EXPIRED,
    category: 'deferred-origination',
    Component: SessionExpiredPage,
  },
  {
    id: 'deferred-origination-cancellation',
    label: 'Cancellation In Progress',
    route: DEFERRED_ORIGINATION_ROUTES.CANCELLATION,
    category: 'deferred-origination',
    Component: CancellationInProgressPage,
  },
  {
    id: 'deferred-origination-cancellation-failed',
    label: 'Cancellation Failed',
    route: DEFERRED_ORIGINATION_ROUTES.CANCELLATION_FAILED,
    category: 'deferred-origination',
    Component: CancellationFailedPage,
  },
  {
    id: 'request-loading',
    label: 'Loading',
    route: REQUEST_ROUTES.LOADING,
    category: 'request',
    Component: RequestLoadingPage,
  },
  {
    id: 'request-welcome',
    label: 'Welcome (Consent)',
    route: REQUEST_ROUTES.WELCOME,
    category: 'request',
    Component: RequestWelcomePage,
  },
  {
    id: 'request-term-esign',
    label: 'E-sign Consent',
    route: `${REQUEST_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'request',
    Component: RequestTermDetailPage,
  },
  {
    id: 'request-term-detail',
    label: 'Terms & Conditions',
    route: `${REQUEST_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'request',
    Component: RequestTermDetailPage,
  },
  {
    id: 'request-legal',
    label: 'Legal Documents',
    route: REQUEST_ROUTES.LEGAL,
    category: 'request',
    Component: LegalPage,
  },
  {
    id: 'request-landing',
    label: 'Landing',
    route: REQUEST_ROUTES.LANDING,
    category: 'request',
    Component: RequestLandingPage,
  },
  {
    id: 'request-landing-returning',
    label: 'Landing (Returning)',
    route: REQUEST_ROUTES.LANDING_RETURNING,
    category: 'request',
    Component: RequestLandingReturningPage,
  },
  {
    id: 'request-home',
    label: 'Home (Requests)',
    route: REQUEST_ROUTES.HOME,
    category: 'request',
    Component: RequestHomePage,
  },
  {
    id: 'request-inbox',
    label: 'Inbox',
    route: REQUEST_ROUTES.INBOX,
    category: 'request',
    Component: RequestInboxPage,
  },
  {
    id: 'request-preferences',
    label: 'Preferences',
    route: REQUEST_ROUTES.PREFERENCES,
    category: 'request',
    Component: RequestPreferencesPage,
  },
  {
    id: 'request-toast',
    label: 'Toast',
    route: REQUEST_ROUTES.TOAST,
    category: 'request',
    Component: RequestToastPage,
  },
  {
    id: 'request-home-restricted',
    label: 'Home (User Restricted)',
    route: REQUEST_ROUTES.HOME_RESTRICTED,
    category: 'request',
    Component: RequestUserRestrictedHomePage,
  },
  {
    id: 'request-transfer',
    label: 'Compose Request',
    route: REQUEST_ROUTES.TRANSFER,
    category: 'request',
    Component: RequestTransferPage,
  },
  {
    id: 'request-add-card',
    label: 'Add Destination Card',
    route: REQUEST_ROUTES.ADD_CARD,
    category: 'request',
    Component: RequestAddCardPage,
  },
  {
    id: 'request-add-card-processing',
    label: 'Add Card Processing',
    route: REQUEST_ROUTES.ADD_CARD_PROCESSING,
    category: 'request',
    Component: RequestAddCardProcessingPage,
  },
  ...phoneGalleryScreens('request', 'request', '/request/phone', 'need-help', 'request'),
  ...smsTermsGalleryScreens('request', 'request', '/request/sms-terms', 'need-help', 'request'),
  {
    id: 'request-minting',
    label: 'Minting',
    route: REQUEST_ROUTES.MINTING,
    category: 'request',
    Component: RequestMintingPage,
  },
  {
    id: 'request-screening',
    label: 'OFAC Screening',
    route: REQUEST_ROUTES.REQUEST_SCREENING,
    category: 'request',
    Component: RequestScreeningPage,
  },
  {
    id: 'request-ready',
    label: 'Request Ready',
    route: REQUEST_ROUTES.REQUEST_READY,
    category: 'request',
    Component: RequestReadyPage,
  },
  {
    id: 'request-receipt',
    label: 'Receipt Summary (Funded)',
    route: `${REQUEST_ROUTES.RECEIPT}/req-gallery-funded`,
    category: 'request',
    Component: RequestReceiptSummaryPage,
  },
  {
    id: 'request-receipt-pending',
    label: 'Receipt Summary (Pending)',
    route: `${REQUEST_ROUTES.RECEIPT}/req-gallery-pending`,
    category: 'request',
    Component: RequestReceiptSummaryPage,
  },
  {
    id: 'request-receipt-accepted',
    label: 'Receipt Summary (Accepted)',
    route: `${REQUEST_ROUTES.RECEIPT}/req-gallery-accepted`,
    category: 'request',
    Component: RequestReceiptSummaryPage,
  },
  {
    id: 'request-receipt-failed',
    label: 'Receipt Summary (Failed)',
    route: `${REQUEST_ROUTES.RECEIPT}/req-gallery-failed`,
    category: 'request',
    Component: RequestReceiptSummaryPage,
  },
  {
    id: 'request-receipt-cancelled',
    label: 'Receipt Summary (Cancelled)',
    route: `${REQUEST_ROUTES.RECEIPT}/req-gallery-cancelled`,
    category: 'request',
    Component: RequestReceiptSummaryPage,
  },
  {
    id: 'request-receipt-expired',
    label: 'Receipt Summary (Expired)',
    route: `${REQUEST_ROUTES.RECEIPT}/req-gallery-expired`,
    category: 'request',
    Component: RequestReceiptSummaryPage,
  },
  {
    id: 'request-support',
    label: 'Contact / Support',
    route: REQUEST_ROUTES.SUPPORT,
    category: 'request',
    Component: RequestSupportPage,
  },
  {
    id: 'request-user-blocked',
    label: 'Requests Unavailable',
    route: REQUEST_ROUTES.USER_BLOCKED,
    category: 'request',
    Component: RequestUserBlockedPage,
  },
  {
    id: 'request-service-unavailable',
    label: 'Service Unavailable',
    route: REQUEST_ROUTES.SERVICE_UNAVAILABLE,
    category: 'request',
    Component: RequestServiceUnavailablePage,
  },
  {
    id: 'request-error',
    label: 'Error',
    route: REQUEST_ROUTES.ERROR,
    category: 'request',
    Component: ErrorPage,
  },
  {
    id: 'request-session-expired',
    label: 'Session Expired',
    route: REQUEST_ROUTES.SESSION_EXPIRED,
    category: 'request',
    Component: SessionExpiredPage,
  },
  {
    id: 'send-loading',
    label: 'Loading (Splash)',
    route: SEND_ROUTES.LOADING,
    category: 'send',
    Component: SendLoadingPage,
  },
  {
    id: 'send-welcome',
    label: 'Welcome (Consent)',
    route: SEND_ROUTES.WELCOME,
    category: 'send',
    Component: SendWelcomePage,
  },
  {
    id: 'send-term-esign',
    label: 'E-sign Consent',
    route: `${SEND_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'send',
    Component: SendTermDetailPage,
  },
  {
    id: 'send-term-detail',
    label: 'Terms & Conditions',
    route: `${SEND_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'send',
    Component: SendTermDetailPage,
  },
  {
    id: 'send-legal',
    label: 'Legal Documents',
    route: SEND_ROUTES.LEGAL,
    category: 'send',
    Component: LegalPage,
  },
  {
    id: 'send-landing',
    label: 'Landing',
    route: SEND_ROUTES.LANDING,
    category: 'send',
    Component: SendLandingPage,
  },
  {
    id: 'send-landing-returning',
    label: 'Landing (Returning)',
    route: SEND_ROUTES.LANDING_RETURNING,
    category: 'send',
    Component: SendLandingReturningPage,
  },
  {
    id: 'send-home',
    label: 'Home (Transfers)',
    route: SEND_ROUTES.HOME,
    category: 'send',
    Component: SendHomePage,
  },
  {
    id: 'send-inbox',
    label: 'Inbox',
    route: SEND_ROUTES.INBOX,
    category: 'send',
    Component: SendInboxPage,
  },
  {
    id: 'send-preferences',
    label: 'Preferences',
    route: SEND_ROUTES.PREFERENCES,
    category: 'send',
    Component: SendPreferencesPage,
  },
  {
    id: 'send-toast',
    label: 'Toast',
    route: SEND_ROUTES.TOAST,
    category: 'send',
    Component: SendToastPage,
  },
  {
    id: 'send-home-deposit-launching',
    label: 'Home (Deposit Launching)',
    route: SEND_ROUTES.HOME_DEPOSIT_LAUNCHING,
    category: 'send',
    Component: SendDepositLaunchingHomePage,
  },
  {
    id: 'send-home-restricted',
    label: 'Home (User Restricted)',
    route: SEND_ROUTES.HOME_RESTRICTED,
    category: 'send',
    Component: SendUserRestrictedHomePage,
  },
  {
    id: 'send-transfer',
    label: 'Transfer (Compose)',
    route: SEND_ROUTES.TRANSFER,
    category: 'send',
    Component: SendTransferPage,
  },
  {
    id: 'send-transfer-first-send',
    label: 'Transfer (First send warning)',
    route: firstSendRoute(SEND_ROUTES.TRANSFER),
    category: 'send',
    Component: SendTransferPage,
  },
  {
    id: 'send-transfer-cvv',
    label: 'Transfer (CVV Prepare)',
    route: SEND_ROUTES.TRANSFER_CVV,
    category: 'send',
    Component: SendCvvPrepareGatePage,
  },
  {
    id: 'send-add-card',
    label: 'Add Card',
    route: SEND_ROUTES.ADD_CARD,
    category: 'send',
    Component: SendAddCardPage,
  },
  {
    id: 'send-billing-address',
    label: 'Billing Address',
    route: SEND_ROUTES.ADD_CARD_ADDRESS,
    category: 'send',
    Component: SendBillingAddressPage,
  },
  {
    id: 'send-add-card-processing',
    label: 'Add Card Processing',
    route: SEND_ROUTES.ADD_CARD_PROCESSING,
    category: 'send',
    Component: SendAddCardProcessingPage,
  },
  ...phoneGalleryScreens('send', 'send', '/send/phone', 'need-help', 'send'),
  ...smsTermsGalleryScreens('send', 'send', '/send/sms-terms', 'need-help', 'send'),
  {
    id: 'send-sending',
    label: 'Sending Money',
    route: SEND_ROUTES.SENDING,
    category: 'send',
    Component: SendSendingMoneyPage,
  },
  {
    id: 'send-how-to-deposit',
    label: 'How to Deposit Cash',
    route: SEND_ROUTES.HOW_TO_DEPOSIT,
    category: 'send',
    Component: SendHowToDepositCashPage,
  },
  {
    id: 'send-receipt',
    label: 'Receipt Summary',
    route: `${SEND_ROUTES.RECEIPT}/op_gallery_send_completed`,
    category: 'send',
    Component: SendReceiptSummaryPage,
  },
  {
    id: 'send-receipt-processing',
    label: 'Receipt Summary (Processing)',
    route: `${SEND_ROUTES.RECEIPT}/op_gallery_send_processing`,
    category: 'send',
    Component: SendReceiptSummaryPage,
  },
  {
    id: 'send-receipt-failed',
    label: 'Receipt Summary (Failed)',
    route: `${SEND_ROUTES.RECEIPT}/op_gallery_send_failed`,
    category: 'send',
    Component: SendReceiptSummaryPage,
  },
  {
    id: 'send-receipt-cancelled',
    label: 'Receipt Summary (Cancelled)',
    route: `${SEND_ROUTES.RECEIPT}/op_gallery_send_canceled`,
    category: 'send',
    Component: SendReceiptSummaryPage,
  },
  {
    id: 'send-receipt-expired',
    label: 'Receipt Summary (Expired)',
    route: `${SEND_ROUTES.RECEIPT}/op_gallery_send_expired`,
    category: 'send',
    Component: SendReceiptSummaryPage,
  },
  {
    id: 'send-support',
    label: 'Contact / Support',
    route: SEND_ROUTES.SUPPORT,
    category: 'send',
    Component: SendSupportPage,
  },
  {
    id: 'send-user-blocked',
    label: 'Sends Unavailable',
    route: SEND_ROUTES.USER_BLOCKED,
    category: 'send',
    Component: SendUserBlockedPage,
  },
  {
    id: 'send-error',
    label: 'Error',
    route: SEND_ROUTES.ERROR,
    category: 'send',
    Component: ErrorPage,
  },
  {
    id: 'send-session-expired',
    label: 'Session Expired',
    route: SEND_ROUTES.SESSION_EXPIRED,
    category: 'send',
    Component: SessionExpiredPage,
  },
  {
    id: 'send-service-unavailable',
    label: 'Service Unavailable',
    route: SEND_ROUTES.SERVICE_UNAVAILABLE,
    category: 'send',
    Component: ServiceUnavailablePage,
  },
  {
    id: 'send-cancellation',
    label: 'Cancellation In Progress',
    route: SEND_ROUTES.CANCELLATION,
    category: 'send',
    Component: CancellationInProgressPage,
  },
  {
    id: 'send-cancellation-failed',
    label: 'Cancellation Failed',
    route: SEND_ROUTES.CANCELLATION_FAILED,
    category: 'send',
    Component: CancellationFailedPage,
  },
  {
    id: 'smart-loading',
    label: 'Splash / Loading',
    route: SMART_ROUTES.LOADING,
    category: 'smart',
    Component: SmartLoadingPage,
  },
  {
    id: 'smart-home',
    label: 'Home',
    route: SMART_ROUTES.HOME,
    category: 'smart',
    Component: SmartHomePage,
  },
  {
    id: 'smart-inbox',
    label: 'Inbox',
    route: SMART_ROUTES.INBOX,
    category: 'smart',
    Component: SmartInboxPage,
  },
  {
    id: 'smart-preferences',
    label: 'Notification preferences',
    route: SMART_ROUTES.PREFERENCES,
    category: 'smart',
    Component: SmartPreferencesPage,
  },
  {
    id: 'smart-toast',
    label: 'Notification toast',
    route: SMART_ROUTES.TOAST,
    category: 'smart',
    Component: SmartToastPage,
  },
  {
    id: 'smart-wizard-intent',
    label: 'Wizard - Intent',
    route: SMART_ROUTES.WIZARD_INTENT,
    category: 'smart',
    Component: SmartWizardIntentPage,
  },
  {
    id: 'smart-wizard-route',
    label: 'Wizard - Route/Amount',
    route: SMART_ROUTES.WIZARD_ROUTE,
    category: 'smart',
    Component: SmartWizardRoutePage,
  },
  {
    id: 'smart-wizard-funding',
    label: 'Wizard - Funding',
    route: SMART_ROUTES.WIZARD_FUNDING,
    category: 'smart',
    Component: SmartWizardFundingPage,
  },
  {
    id: 'smart-wizard-payout',
    label: 'Wizard - Payout',
    route: SMART_ROUTES.WIZARD_PAYOUT,
    category: 'smart',
    Component: SmartWizardPayoutPage,
  },
  {
    id: 'smart-collect-recipient',
    label: 'Collect - Recipient name',
    route: SMART_ROUTES.COLLECT_RECIPIENT,
    category: 'smart',
    Component: SmartCollectRecipientPage,
  },
  {
    id: 'smart-collect-summary',
    label: 'Collect - Summary',
    route: SMART_ROUTES.COLLECT_SUMMARY,
    category: 'smart',
    Component: SmartCollectSummaryPage,
  },
  {
    id: 'smart-collect-summary-first-send',
    label: 'Collect - Summary (First send warning)',
    route: firstSendRoute(SMART_ROUTES.COLLECT_SUMMARY),
    category: 'smart',
    Component: SmartCollectSummaryPage,
  },
  ...phoneGalleryScreens('smart', 'smart', '/smart/phone', 'smart'),
  {
    id: 'smart-sms-terms',
    label: 'SMS terms',
    route: SMART_ROUTES.SMS_TERMS,
    category: 'smart',
    Component: SmartSmsTermsPage,
  },
  {
    id: 'smart-sms-terms-detail',
    label: 'SMS terms (detail)',
    route: SMART_ROUTES.SMS_TERMS_DETAIL,
    category: 'smart',
    Component: SmartSmsTermsDetailPage,
  },
  {
    id: 'smart-kyc-checking',
    label: 'KYC - Checking',
    route: SMART_ROUTES.KYC_CHECKING,
    category: 'smart',
    Component: SmartKycCheckingPage,
  },
  {
    id: 'smart-kyc-intro',
    label: 'KYC - Intro',
    route: SMART_ROUTES.KYC_INTRO,
    category: 'smart',
    Component: SmartKycIntroPage,
  },
  {
    id: 'smart-kyc-error',
    label: 'KYC - Error',
    route: SMART_ROUTES.KYC_ERROR,
    category: 'smart',
    Component: SmartKycErrorPage,
  },
  {
    id: 'smart-cip-claiming',
    label: 'CIP - Claiming',
    route: SMART_ROUTES.CIP_CLAIMING,
    category: 'smart',
    Component: SmartCipClaimingPage,
  },
  {
    id: 'smart-cip-scan-id',
    label: 'CIP - Scan ID',
    route: SMART_ROUTES.CIP_SCAN_ID,
    category: 'smart',
    Component: SmartCipScanIdPage,
  },
  {
    id: 'smart-cip-scan-id-loading',
    label: 'CIP - Scan ID (OCR)',
    route: SMART_ROUTES.CIP_SCAN_ID_LOADING,
    category: 'smart',
    Component: SmartCipScanIdLoadingPage,
  },
  {
    id: 'smart-cip-identity-review',
    label: 'CIP - Identity review',
    route: SMART_ROUTES.CIP_IDENTITY_REVIEW,
    category: 'smart',
    Component: SmartCipIdentityReviewPage,
  },
  {
    id: 'smart-cip-address',
    label: 'CIP - Address',
    route: SMART_ROUTES.CIP_ADDRESS,
    category: 'smart',
    Component: SmartCipAddressPage,
  },
  {
    id: 'smart-cip-liveness',
    label: 'CIP - Liveness (loading)',
    route: SMART_ROUTES.CIP_LIVENESS,
    category: 'smart',
    Component: SmartCipLivenessLoadingPage,
  },
  {
    id: 'smart-cip-liveness-capture',
    label: 'CIP - Liveness (capture stub)',
    hint: 'AWS FaceLivenessDetector omitted — oval stage only',
    route: SMART_ROUTES.CIP_LIVENESS_CAPTURE,
    category: 'smart',
    Component: SmartCipLivenessCapturePage,
  },
  {
    id: 'smart-cip-liveness-retry',
    label: 'CIP - Liveness (retry)',
    route: SMART_ROUTES.CIP_LIVENESS_RETRY,
    category: 'smart',
    Component: SmartCipLivenessRetryPage,
  },
  {
    id: 'smart-cip-completion',
    label: 'CIP - Completion (processing)',
    route: SMART_ROUTES.CIP_COMPLETION,
    category: 'smart',
    Component: SmartCipCompletionProcessingPage,
  },
  {
    id: 'smart-cip-completion-success',
    label: 'CIP - Completion (success)',
    route: SMART_ROUTES.CIP_COMPLETION_SUCCESS,
    category: 'smart',
    Component: SmartCipCompletionSuccessPage,
  },
  {
    id: 'smart-committing',
    label: 'Committing',
    route: SMART_ROUTES.COMMITTING,
    category: 'smart',
    Component: SmartCommittingPage,
  },
  {
    id: 'smart-merchant-picker',
    label: 'Merchant picker',
    route: SMART_ROUTES.MERCHANT_PICKER,
    category: 'smart',
    Component: SmartMerchantPickerPage,
  },
  {
    id: 'smart-barcode',
    label: 'Barcode',
    route: SMART_ROUTES.BARCODE,
    category: 'smart',
    Component: SmartBarcodePage,
  },
  {
    id: 'smart-done-send',
    label: 'Done (Send)',
    route: SMART_ROUTES.DONE_SEND,
    category: 'smart',
    Component: SmartSendDonePage,
  },
  {
    id: 'smart-done-share',
    label: 'Share link done',
    route: SMART_ROUTES.DONE_SHARE,
    category: 'smart',
    Component: SmartShareLinkDonePage,
  },
  {
    id: 'smart-error',
    label: 'Error',
    route: SMART_ROUTES.ERROR,
    category: 'smart',
    Component: SmartErrorPage,
  },
  {
    id: 'smart-claim-fail',
    label: 'Claim fail (no action)',
    route: SMART_ROUTES.CLAIM_FAIL,
    category: 'smart',
    Component: SmartClaimFailPage,
  },
  {
    id: 'smart-claim-fail-return',
    label: 'Claim fail (return to app)',
    route: SMART_ROUTES.CLAIM_FAIL_RETURN,
    category: 'smart',
    Component: SmartClaimFailReturnPage,
  },
  {
    id: 'lola-loading',
    label: 'Loading (Splash)',
    route: LOLA_ROUTES.LOADING,
    category: 'lola',
    Component: LolaLoadingPage,
  },
  {
    id: 'lola-welcome',
    label: 'Welcome (Consent)',
    route: LOLA_ROUTES.WELCOME,
    category: 'lola',
    Component: LolaWelcomePage,
  },
  {
    id: 'lola-term-esign',
    label: 'E-sign Consent',
    route: `${LOLA_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'lola',
    Component: LolaTermDetailPage,
  },
  {
    id: 'lola-term-detail',
    label: 'Terms & Conditions',
    route: `${LOLA_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'lola',
    Component: LolaTermDetailPage,
  },
  {
    id: 'lola-legal',
    label: 'Legal Documents',
    route: LOLA_ROUTES.LEGAL,
    category: 'lola',
    Component: LegalPage,
  },
  {
    id: 'lola-confirmation',
    label: 'Confirmation',
    route: LOLA_ROUTES.CONFIRMATION,
    category: 'lola',
    Component: LolaConfirmationPage,
  },
  {
    id: 'lola-confirmation-first-send',
    label: 'Confirmation (First send warning)',
    route: firstSendRoute(LOLA_ROUTES.CONFIRMATION),
    category: 'lola',
    Component: LolaConfirmationPage,
  },
  {
    id: 'lola-confirmation-cvv',
    label: 'Confirmation (CVV Prepare)',
    route: LOLA_ROUTES.CONFIRMATION_CVV,
    category: 'lola',
    Component: LolaCvvPrepareGatePage,
  },
  {
    id: 'lola-add-card',
    label: 'Add Card',
    route: LOLA_ROUTES.ADD_CARD,
    category: 'lola',
    Component: LolaAddCardPage,
  },
  {
    id: 'lola-add-card-address',
    label: 'Billing Address',
    route: LOLA_ROUTES.ADD_CARD_ADDRESS,
    category: 'lola',
    Component: LolaBillingAddressPage,
  },
  {
    id: 'lola-add-card-processing',
    label: 'Add Card Processing',
    route: LOLA_ROUTES.ADD_CARD_PROCESSING,
    category: 'lola',
    Component: LolaAddCardProcessingPage,
  },
  {
    id: 'lola-cip',
    label: 'CIP (Identity)',
    route: LOLA_ROUTES.CIP,
    category: 'lola',
    Component: LolaCipPage,
  },
  {
    id: 'lola-transferring',
    label: 'Transferring',
    route: LOLA_ROUTES.TRANSFERRING,
    category: 'lola',
    Component: LolaTransferringPage,
  },
  {
    id: 'lola-sending',
    label: 'Sending',
    route: LOLA_ROUTES.SENDING,
    category: 'lola',
    Component: LolaSendingMoneyPage,
  },
  {
    id: 'lola-how-to-cash-deposit',
    label: 'How to Pay in Cash',
    route: LOLA_ROUTES.HOW_TO_CASH_DEPOSIT,
    category: 'lola',
    Component: LolaHowToCashDepositPage,
  },
  {
    id: 'lola-route-unavailable',
    label: 'Route Unavailable',
    route: LOLA_ROUTES.ROUTE_UNAVAILABLE,
    category: 'lola',
    Component: LolaRouteUnavailablePage,
  },
  {
    id: 'lola-link-already-used',
    label: 'Link Already Used',
    route: LOLA_ROUTES.LINK_ALREADY_USED,
    category: 'lola',
    Component: LolaLinkAlreadyUsedPage,
  },
  {
    id: 'lola-error',
    label: 'Error',
    route: LOLA_ROUTES.ERROR,
    category: 'lola',
    Component: ErrorPage,
  },
  {
    id: 'lola-session-expired',
    label: 'Session Expired',
    route: LOLA_ROUTES.SESSION_EXPIRED,
    category: 'lola',
    Component: SessionExpiredPage,
  },
  {
    id: 'lola-service-unavailable',
    label: 'Service Unavailable',
    route: LOLA_ROUTES.SERVICE_UNAVAILABLE,
    category: 'lola',
    Component: ServiceUnavailablePage,
  },
  {
    id: 'starter-loading',
    label: 'Loading (Splash)',
    route: STARTER_ROUTES.LOADING,
    category: 'starter',
    Component: StarterLoadingPage,
  },
  {
    id: 'starter-welcome',
    label: 'Welcome (Consent)',
    route: STARTER_ROUTES.WELCOME,
    category: 'starter',
    Component: StarterWelcomePage,
  },
  {
    id: 'starter-landing',
    label: 'Landing',
    route: STARTER_ROUTES.LANDING,
    category: 'starter',
    Component: StarterLandingPage,
  },
  ...phoneGalleryScreens('starter', 'starter', '/starter/phone', 'plain'),
  {
    id: 'starter-term-esign',
    label: 'E-sign Consent',
    route: `${STARTER_ROUTES.TERM_DETAIL}?entryId=esign`,
    category: 'starter',
    Component: StarterTermDetailPage,
  },
  {
    id: 'starter-term-detail',
    label: 'Terms & Conditions',
    route: `${STARTER_ROUTES.TERM_DETAIL}?entryId=terms`,
    category: 'starter',
    Component: StarterTermDetailPage,
  },
  {
    id: 'starter-legal',
    label: 'Legal Documents',
    route: STARTER_ROUTES.LEGAL,
    category: 'starter',
    Component: LegalPage,
  },
  {
    id: 'starter-rotate-device',
    label: 'Rotate Device',
    route: STARTER_ROUTES.ROTATE_DEVICE,
    category: 'starter',
    Component: StarterRotateToPortraitPage,
  },
  {
    id: 'starter-error',
    label: 'Error',
    route: STARTER_ROUTES.ERROR,
    category: 'starter',
    Component: ErrorPage,
  },
  {
    id: 'starter-session-expired',
    label: 'Session Expired',
    route: STARTER_ROUTES.SESSION_EXPIRED,
    category: 'starter',
    Component: SessionExpiredPage,
  },
  {
    id: 'starter-service-unavailable',
    label: 'Service Unavailable',
    route: STARTER_ROUTES.SERVICE_UNAVAILABLE,
    category: 'starter',
    Component: ServiceUnavailablePage,
  },
  {
    id: 'consumer-auth-sign-in',
    label: 'Continue (from claim)',
    route: CONSUMER_AUTH_ROUTES.SIGN_IN,
    category: 'consumer-auth',
    Component: AuthSignInPage,
  },
  {
    id: 'consumer-auth-sign-in-after-logout',
    label: 'Continue (after logout)',
    route: CONSUMER_AUTH_ROUTES.SIGN_IN_AFTER_LOGOUT,
    category: 'consumer-auth',
    Component: AuthSignInAfterLogoutPage,
  },
  {
    id: 'consumer-auth-sign-in-bind-failed',
    label: 'Continue (bind failed, signed out)',
    route: CONSUMER_AUTH_ROUTES.SIGN_IN_BIND_FAILED,
    category: 'consumer-auth',
    Component: AuthSignInBindFailedPage,
  },
  {
    id: 'consumer-auth-code',
    label: 'Verify code',
    route: CONSUMER_AUTH_ROUTES.CODE,
    category: 'consumer-auth',
    Component: AuthCodePage,
  },
  {
    id: 'consumer-auth-code-resend',
    label: 'Verify code (resend ready)',
    route: CONSUMER_AUTH_ROUTES.CODE_RESEND,
    category: 'consumer-auth',
    Component: AuthCodeResendReadyPage,
  },
  {
    id: 'consumer-auth-code-incorrect',
    label: 'Verify code (invalid)',
    route: CONSUMER_AUTH_ROUTES.CODE_INCORRECT,
    category: 'consumer-auth',
    Component: AuthCodeIncorrectPage,
  },
  {
    id: 'consumer-auth-binding',
    label: 'Binding',
    route: CONSUMER_AUTH_ROUTES.BINDING,
    category: 'consumer-auth',
    Component: AuthBindingPage,
  },
  {
    id: 'consumer-auth-pending',
    label: 'Pending session',
    route: CONSUMER_AUTH_ROUTES.PENDING,
    category: 'consumer-auth',
    Component: AuthPendingPage,
  },
  {
    id: 'consumer-auth-missing-key',
    label: 'Missing key',
    route: CONSUMER_AUTH_ROUTES.MISSING_KEY,
    category: 'consumer-auth',
    Component: AuthMissingKeyPage,
  },
  {
    id: 'consumer-auth-error-bind',
    label: 'Bind error',
    route: CONSUMER_AUTH_ROUTES.ERROR_BIND,
    category: 'consumer-auth',
    Component: AuthErrorBindPage,
  },
  {
    id: 'consumer-auth-error-generic',
    label: 'Auth error',
    route: CONSUMER_AUTH_ROUTES.ERROR_GENERIC,
    category: 'consumer-auth',
    Component: AuthErrorGenericPage,
  },
  {
    id: 'starter-maintenance',
    label: 'Maintenance',
    route: STARTER_ROUTES.MAINTENANCE,
    category: 'starter',
    Component: MaintenanceGalleryPage,
  },
  {
    id: 'm2m-maintenance',
    label: 'Maintenance',
    route: M2M_ROUTES.MAINTENANCE,
    category: 'm2m',
    Component: MaintenanceGalleryPage,
  },
  {
    id: 'send-maintenance',
    label: 'Maintenance',
    route: SEND_ROUTES.MAINTENANCE,
    category: 'send',
    Component: MaintenanceGalleryPage,
  },
  {
    id: 'smart-maintenance',
    label: 'Maintenance',
    route: SMART_ROUTES.MAINTENANCE,
    category: 'smart',
    Component: SmartMaintenancePage,
  },
  {
    id: 'deferred-origination-maintenance',
    label: 'Maintenance',
    route: DEFERRED_ORIGINATION_ROUTES.MAINTENANCE,
    category: 'deferred-origination',
    Component: MaintenanceGalleryPage,
  },
  {
    id: 'payout-claim-maintenance',
    label: 'Maintenance',
    route: PAYOUT_CLAIM_ROUTES.MAINTENANCE,
    category: 'payout-claim',
    Component: MaintenanceGalleryPage,
  },
  {
    id: 'fund-request-maintenance',
    label: 'Maintenance',
    route: FUND_REQUEST_ROUTES.MAINTENANCE,
    category: 'fund-request',
    Component: MaintenanceGalleryPage,
  },
  {
    id: 'cash-deposit-maintenance',
    label: 'Maintenance',
    route: CASH_DEPOSIT_ROUTES.MAINTENANCE,
    category: 'cash-deposit',
    Component: MaintenanceGalleryPage,
  },
  {
    id: 'request-maintenance',
    label: 'Maintenance',
    route: REQUEST_ROUTES.MAINTENANCE,
    category: 'request',
    Component: MaintenanceGalleryPage,
  },
  {
    id: 'lola-maintenance',
    label: 'Maintenance',
    route: LOLA_ROUTES.MAINTENANCE,
    category: 'lola',
    Component: MaintenanceGalleryPage,
  },

];

/** Screens grouped by functional area for the Control Dock. */
export const galleryScreenGroups: GalleryScreenGroup[] =
  GALLERY_SCREEN_GROUP_DEFS.map((group) => ({
    ...group,
    screens: galleryScreens.filter((screen) => screen.category === group.id),
  })).filter((group) => group.screens.length > 0);

/** Resolve the group id for a given route path (query string ignored). */
export const getScreenGroupForRoute = (
  route: string,
): GalleryScreenCategory | undefined => {
  const path = route.split('?')[0];
  return galleryScreens.find(
    (screen) => screen.route.split('?')[0] === path,
  )?.category;
};

/** Dock highlight: path plus optional `?query` must match. */
export const isGalleryScreenActive = (
  screenRoute: string,
  pathname: string,
  search: string,
): boolean => {
  const [path, query] = screenRoute.split('?');
  if (pathname !== path) return false;
  if (!query) return search === '';
  return search === `?${query}`;
};

/**
 * Default screen shown when the gallery loads: the first screen of the first
 * group in the Control Dock. Derived from the list so reordering the dock
 * keeps the landing screen in sync.
 */
export const DEFAULT_SCREEN_ROUTE =
  galleryScreenGroups[0]?.screens[0]?.route ?? M2M_ROUTES.LANDING;
